import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Title } from "@angular/platform-browser";
import { sortBy } from "lodash";

@Component({
  selector: "school-usage-table",
  templateUrl: "./school-usage-table.component.html",
  styleUrls: ["./school-usage-table.component.scss"],
})
export class SchoolUsageTableComponent implements OnInit {
  @Input() schools;
  displayedColumns: string[] = ["name", "sparkline", "current"];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private titleService: Title) {}

  ngOnInit() {
    this.schools = sortBy(this.schools, ["name"]);
    this.dataSource = new MatTableDataSource(this.schools);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  getSchoolOverallTooltipDesc(school) {
    let tooltipDesc;
    if (
      school &&
      school.charts &&
      school.charts.overall &&
      school.charts.overall.chartData &&
      school.charts.overall.chartData[0]
    ) {
      tooltipDesc = `${school.charts.overall.chartData[0].numerator} of ${school.charts.overall.chartData[0].denominator}
        ${school.charts.overall.chartData[0].descriptor} in the current month`;
    }
    return tooltipDesc;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  isCentralOffice(name) {
    return name.toLowerCase() == "central office (excludes admins)";
  }
}
